package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
enum class RedwolfErrorCodes {
    WALLET_DELETE_LAST_CARD_ACTIVE_SUBSCRIPTION,
    UNAUTHORIZED
}
